import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useEnableNebulySettings } from '../../hooks/useNebulySettings';
import { ConversationsTable } from './components/ConversationsTable';
import { EnableToggle } from './components/EnableToggle';
import { InsightsHeader } from './components/Header/InsightsHeader';
import { SummaryTable } from './components/SummaryTable';
import { TopicsTable } from './components/TopicsTable';
import { AgentInsightsContextProvider } from './contex/AgentInsightsContext';
import { useAgentInsightsContext } from './contex/useAgentInsightsContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const LoadingPage = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const AgentInsightsPage = () => {
    const { isConversationView } = useAgentInsightsContext();
    const { isLoading: isEnableNebulySettingsLoading } = useEnableNebulySettings();

    if (isEnableNebulySettingsLoading) {
        return (
            <LoadingPage>
                <CircularProgress size={96} />
            </LoadingPage>
        );
    }

    return (
        <Container>
            <InsightsHeader />

            <EnableToggle />

            {!isConversationView && (
                <>
                    <SummaryTable />
                    <TopicsTable />
                </>
            )}
            {isConversationView && <ConversationsTable />}
        </Container>
    );
};

const AgentInsightsPageWrapper = () => {
    return (
        <AgentInsightsContextProvider>
            <AgentInsightsPage />
        </AgentInsightsContextProvider>
    );
};

export { AgentInsightsPageWrapper as AgentInsightsPage };
